<template lang="html">
  <v-snackbar v-model="show" top :class="['snackbar-soft z-index-9999', { 'snackbar-success-soft': type === 'success', 'snackbar-error-soft': type === 'error' }]">
    <div class="d-flex">
      <div class="mr-4 d-flex align-center">
        <img v-if="type === 'success'" src="@/assets/images/v2/img/icon_success.png" alt="Success" class="image-24">
        <img v-else-if="type === 'error'" src="@/assets/images/v2/img/icon_warning.png" alt="Warning" class="image-24">
      </div>
      <div class="font-18 font-weight-700 line-height-normal">
        {{ message }}
      </div>
    </div>
  </v-snackbar>
</template>
<script>
export default {
  name: 'Alert',
  props: {
    value: {
      default: false,
      type: Boolean
    },
    message: {
      default: '',
      type: String
    },
    type: {
      default: 'success',
      type: String
    }
  },
  computed: {
    'show': {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
